import { path, httpService } from '@commons';

const args = { ...path, path: '/pluviometroDigital' };

export function getDashboardPluviometro(dataInicial, dataFinal, estacaoMeteorologicaId) {
    // Backend espera: startDate, endDate, weatherStationId (todos obrigatórios)
    if (!estacaoMeteorologicaId) {
        throw new Error('Estação Meteorológica é obrigatória');
    }

    const params = `?startDate=${dataInicial}&endDate=${dataFinal}&weatherStationId=${estacaoMeteorologicaId}`;
    return httpService.get({...args, args: `/chart-data${params}`});
}
